import React from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

const FormInput = (props: any) => <input {...props} />;

const FormInputStyle = () => css`
  ${mq({
    fontSize: ['1em', '1.3em'],
    height: ['55px'],
    border: `2px solid ${Colors.grayLight9}`,
    borderRadius: '7px',
    width: '100%',
    padding: '10px',
    // maxWidth: ['94%', '100%'],
  })};
`;

const FormInputStyled = styled(FormInput)`
  ${FormInputStyle}
`;

export default FormInputStyled;
